import axiosInstance from './api';

const apiErrorHandler = e => {
  if (e.response && e.response.data && e.response.data.message) {
    throw new Error(e.response.data.message);
  } else if (e.message) {
    throw e;
  } else {
    throw new Error('Unexpected error occured when calling api. Please contact admin.');
  }
};

export const getSearchProperties = async query =>
  await axiosInstance
    .get(`/external/building`, { params: { ...query } })
    .then(res => res.data)
    .catch(apiErrorHandler);

export const searchProperties = (name, selectedBuildings) =>
  axiosInstance.get('/external/building/search', { params: { name, buildingsString: selectedBuildings.join(',') } }).then(res => res.data);
